import { Injectable, Injector } from "@angular/core";
import { ServiceBase } from "../../service-base";
import { Observable } from "rxjs";
import { AssetPageConfiguration } from "src/app/core/models/asset/configuration/asset-page-configuration.model";
import { AssetChartSettingRequestModel } from "src/app/core/models/asset/configuration/asset-chart-setting-request.model";
import { BasicAssetPageModel } from "src/app/core/models/asset/configuration/basic-asset-page.model";

@Injectable({
    providedIn: 'root'
})
export class AssetPageService extends ServiceBase {

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * Gets asset page configuration by page name.
     * @returns Observable with the asset page configuration
     */
    public getPageConfiguration(pageName: string): Observable<AssetPageConfiguration> {
        let assetChartSettingRequest = new AssetChartSettingRequestModel();
        assetChartSettingRequest.pageName = pageName;
        return this.httpQueue.post<AssetPageConfiguration>(`${this.baseUrl}v1/AssetPage/GetPageConfiguration`, assetChartSettingRequest);
    }

    /**
     * Gets basic asset pages.
     * @returns Observable with the basic asset pages
     */
    public getBasicAssetPages(assetId: string): Observable<BasicAssetPageModel[]> {
        return this.httpQueue.get<BasicAssetPageModel[]>(`${this.baseUrl}v1/AssetPage/GetBasicAssetPages/${assetId}`);
    }
}